<template>
  <div class="progress-block">
    <p>{{ title }}</p>
    <div class="progress-bar-wrapper">
      <span class="empty" @mouseover.stop="tooltip({ text: tooltipContent, event: $event })" />
      <progress-bar dataCy="common-progress-bar" :all="max" :fill="value" :color="color" />
    </div>
  </div>
</template>

<script>
import ProgressBar from './ProgressBar.vue';
import ToolTipRenderMixin from '@/mixins/ToolTipRenderMixin';

export default {
  name: 'ProgressBlock',
  mixins: [ToolTipRenderMixin],
  components: {
    'progress-bar': ProgressBar,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    tooltipTitle: {
      type: String,
      required: false,
      default: '',
    },
    value: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    },
    color: {
      type: String,
      required: false,
    },
  },
  computed: {
    tooltipContent() {
      const calculated = this.max ? (this.value * 100) / this.max : 0;
      return `${this.tooltipTitle}<br/>
                    <b>${this.value}/${this.max} (${calculated}%)</b>`;
    },
  },
};
</script>

<style lang="scss" scoped>
.progress-block {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 4px;
  justify-content: space-between;
  & > p {
    font-family: Roboto, sans-serif;
    font-size: 9px;
    color: kw-color(kw-grey, 1);
    margin: 0;
    min-width: 70px;
  }
  .progress-bar-wrapper {
    position: relative;
    flex: 1;
    display: flex; // Added to ensure progress bar fills wrapper
    & > div {
      width: 100%;
      height: 6px;
      margin: 0;
    }
    .empty {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
  }
}
</style>
